import React from 'react'

export default function footer(props) {
  return (
    <footer>
      COPYRIGHT © ALL RIGHTS RESERVED
    </footer>
  )
}